import { sendRequest } from "../../hooks/requests/useRequest";

export async function getPaintInformed() {
    const requestOptions = {
        method: 'GET'
    };

    const response = await sendRequest(requestOptions, `InformedConsent/ListPaintInformed`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            msg: response?.data?.msg
        };
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}


export async function getCancell() {
    const requestOptions = {
        method: 'GET'
    };

    const response = await sendRequest(requestOptions, `CancellationReazonSample/List`);

    if (response.code === 200)
        return {
            code: response.code,
            data: response.data
        }
    else if (response.code === 401)
        return {
            code: response.code,
            msg: response?.data?.msg
        };
    else
        return {
            code: response.code,
            msg: response?.data?.msg
        };
}




export async function saveRefused({
    nim, time_init, time_end, cancellation, testCI, imageFirm
}) {
    const body = {
        nim,
        time_init,
        time_end,
        cancellation,
        testCI,
        imageFirm
    };

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "Sample/UpdateCiSample"
    );

    if (response.code === 200)
        return {
            code: response?.code,
            data: response?.data,
        }

    else if (response.code === 401)
        return response.data;
    else
        return {
            code: response?.code,
            data: response?.data.msg,
        };

}


export async function saveSurvey({
    nim, time_init, time_end, cancellation, testCI, imageFirm
}) {
    const body = {
        nim,
        time_init,
        time_end,
        cancellation,
        testCI,
        imageFirm
    };

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "Sample/UpdateCiSample"
    );

    if (response.code === 200)
        return {
            code: response?.code,
            data: response?.data,
        }

    else if (response.code === 401)
        return response.data;
    else
        return {
            code: response?.code,
            data: response?.data.msg,
        };

}




